import { ca } from '@cian/analytics';

export function trackClearClick() {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'clear_filters',
    label: 'From_cat_filters',
  });
}

function getLabel(searchString: string): string {
  const searchStringRaw = searchString.split('?');

  return searchStringRaw.length > 1 ? searchStringRaw[1] : searchStringRaw[0];
}

export function trackAdvancedFiltersSearchClick(searchString: string) {
  const label = getLabel(searchString);

  ca('event', {
    name: 'oldevent',
    category: 'FastFilters',
    action: 'click_filters_block',
    label,
  });
}
